import React, { useContext, useEffect } from "react";
import {
  Area1Set,
  Area2Set,
  ModeSet,
  Rotate1Set,
  Rotate2Set,
  Static2Map1Set,
  Static2Map2Set,
  Map1Set,
  Map2Set,
} from "../App";
import { Cartesian3, Math as Cesium_Math } from "cesium";
import { oldmap, oldphoto, palemap, photo, stdmap } from "../cesiumsetting";

export const FuncOnloadZoomTenkei = ({ rfcs, rfcs2 }) => {
  const { area1set } = useContext(Area1Set);
  const { area2set } = useContext(Area2Set);
  const { modeset } = useContext(ModeSet);
  const { setRotate1Set } = useContext(Rotate1Set);
  const { setRotate2Set } = useContext(Rotate2Set);
  const { static2map1set } = useContext(Static2Map1Set);
  const { static2map2set } = useContext(Static2Map2Set);
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { map2set, setMap2Set } = useContext(Map2Set);

  useEffect(() => {
    // 必要なオブジェクトが揃っていなければ処理を中断

    const delays = [0, 2, 4, 10, 100, 500, 1000, 2000, 3000];

    delays.forEach((delay) => {
      setTimeout(() => {
        if (
          rfcs.current.cesiumElement &&
          static2map1set.tenkei_lon &&
          rfcs2.current.cesiumElement
        ) {
          // if (!rfcs?.current?.cesiumElement || !static2map1set?.tenkei_lon) return;
          // メイン処理を少し遅延して実行
          if (modeset == 4 || modeset == 6 || modeset == 7) {
            // console.log("１つ目");
            if (static2map1set.tenkei_map == 1) {
              setMap1Set(palemap);
              setMap2Set(palemap);
            } else if (static2map1set.tenkei_map == 2) {
              setMap1Set(stdmap);
              setMap2Set(stdmap);
            }
            // if (static2map1set.tenkei_lon) {
            // if ([4, 6, 7].includes(modeset)) {
            // flyTo を利用する場合
            // delays.forEach((delay) => {
            // setTimeout(() => {
            setRotate1Set(false);
            setRotate2Set(false);
            // rfcs 用カメラの flyTo
            rfcs.current.cesiumElement.camera.flyTo({
              destination: Cartesian3.fromDegrees(
                Number(static2map1set.tenkei_lon),
                Number(static2map1set.tenkei_lat),
                Number(static2map1set.tenkei_height)
              ),
              orientation: {
                heading: Cesium_Math.toRadians(
                  Number(static2map1set.tenkei_heading)
                ),
                pitch: Cesium_Math.toRadians(
                  Number(static2map1set.tenkei_pitch)
                ),
                roll: Cesium_Math.toRadians(Number(static2map1set.tenkei_roll)),
              },
              duration: 0,
            });
            // rfcs2 用カメラの flyTo (存在する場合のみ)
            if (
              rfcs2.current.cesiumElement &&
              static2map2set &&
              static2map2set.tenkei_lon_2
            ) {
              // console.log("２つ目");

              if (static2map2set.tenkei_lon_2) {
                rfcs2.current.cesiumElement.camera.flyTo({
                  destination: Cartesian3.fromDegrees(
                    Number(static2map2set.tenkei_lon_2),
                    Number(static2map2set.tenkei_lat_2),
                    Number(static2map2set.tenkei_height)
                  ),
                  orientation: {
                    heading: Cesium_Math.toRadians(
                      Number(static2map2set.tenkei_heading)
                    ),
                    pitch: Cesium_Math.toRadians(
                      Number(static2map2set.tenkei_pitch)
                    ),
                    roll: Cesium_Math.toRadians(
                      Number(static2map2set.tenkei_roll)
                    ),
                  },
                  duration: 0,
                });
              }
            }
            // }, delay);
            // });
            // }
          } else {
            // console.log("３つ目");

            // zoomTo を利用する場合
            rfcs.current.cesiumElement.zoomTo(
              rfcs.current.cesiumElement.entities
            );
            // delays.forEach((delay) => {
            // setTimeout(() => {
            setRotate1Set(false);
            setRotate2Set(false);
            rfcs.current.cesiumElement.zoomTo(
              rfcs.current.cesiumElement.entities
            );
            // }, delay);
            // });

            if (rfcs2.current.cesiumElement) {
              rfcs2.current.cesiumElement.zoomTo(
                rfcs.current.cesiumElement.entities
              );
              // delays.forEach((delay) => {
              // setTimeout(() => {
              setRotate1Set(false);
              setRotate2Set(false);
              rfcs2.current.cesiumElement.zoomTo(
                rfcs2.current.cesiumElement.entities
              );
              // }, delay);
              // });
            }
          }
        } else if (
          rfcs.current.cesiumElement &&
          rfcs2.current.cesiumElement &&
          static2map1set.tenkei_city &&
          !static2map1set.tenkei_lon
        ) {
          // console.log("４つ目");

          // const delays = [0, 2, 4, 10, 100, 500, 1000, 2000];
          // zoomTo を利用する場合
          rfcs.current.cesiumElement.zoomTo(
            rfcs.current.cesiumElement.entities
          );
          // delays.forEach((delay) => {
          // setTimeout(() => {
          setRotate1Set(false);
          setRotate2Set(false);
          rfcs.current.cesiumElement.zoomTo(
            rfcs.current.cesiumElement.entities
          );
          // }, delay);
          // });

          if (rfcs2.current.cesiumElement) {
            // console.log("５つ目");

            rfcs2.current.cesiumElement.zoomTo(
              rfcs.current.cesiumElement.entities
            );
            // delays.forEach((delay) => {
            // setTimeout(() => {
            setRotate1Set(false);
            setRotate2Set(false);
            rfcs2.current.cesiumElement.zoomTo(
              rfcs2.current.cesiumElement.entities
            );
            // }, delay);
            // });
          }
        } else if (
          rfcs.current.cesiumElement && modeset == 9999999
        ) {
          // console.log("４つ目");

          // const delays = [0, 2, 4, 10, 100, 500, 1000, 2000];
          // zoomTo を利用する場合
          rfcs.current.cesiumElement.zoomTo(
            rfcs.current.cesiumElement.entities
          );
          // delays.forEach((delay) => {
          // setTimeout(() => {
          setRotate1Set(false);
          setRotate2Set(false);
          rfcs.current.cesiumElement.zoomTo(
            rfcs.current.cesiumElement.entities
          );
          // }, delay);
          // });

          // if (rfcs2.current.cesiumElement) {
          //   // console.log("５つ目");

          //   rfcs2.current.cesiumElement.zoomTo(
          //     rfcs.current.cesiumElement.entities
          //   );
          //   // delays.forEach((delay) => {
          //   // setTimeout(() => {
          //   setRotate1Set(false);
          //   setRotate2Set(false);
          //   rfcs2.current.cesiumElement.zoomTo(
          //     rfcs2.current.cesiumElement.entities
          //   );
          //   // }, delay);
          //   // });
          // }
        }
      }, delay);
    });
  }, [
    rfcs,
    rfcs2,
    area1set,
    area2set,
    modeset,
    // setRotate1Set,
    // setRotate2Set,
    static2map1set,
    static2map2set,
  ]);

  return null;
};

export default FuncOnloadZoomTenkei;
